import UserDetail from './UserDetail';
import Users from './Users';

export { UserDetail };
export default Users;
